import Loading_spinner from './loading_spinner.js';


export default Loading_spinner;

export {
    Loading_spinner
}